import Enumerable from "linq";
import store from "../../store";
import { IEraConfiguration } from "../configuration";

export class EraAsJapaneseCalendar {
  private constructor(
    public readonly name: string,
    public readonly shortName: string,
    public readonly initial: string,
    public readonly year: number,
  ) {
  }

  static from(source: Date, eraName?: string): EraAsJapaneseCalendar {
    const found = EraAsJapaneseCalendar.findConfiguration(source, eraName);
    return !found
      ? null
      : new EraAsJapaneseCalendar(
        found.name,
        found.shortName,
        found.initial,
        source.getFullYear() - found.origin.year + 1,
      );
  }

  private static findConfiguration(source: Date, eraName?: string): IEraConfiguration {
    const found = Enumerable.from(store.state.configuration.system.date.japaneseEras)
      .firstOrDefault(e => eraName ? (e.name === eraName) : ((new Date(e.origin.year, e.origin.month - 1, e.origin.day)).getTime() <= source.getTime()));
    return !found
      ? Enumerable.from(store.state.configuration.system.date.japaneseEras).lastOrDefault()
      : found;
  }
}
